module.exports = __webpack_public_path__ + "img/pin_waypoint_outline.88bc9c9.png";